import http from 'common/http'
import {
  subscriptionsFetched,
  harvestedAreaFetched,
  paymentInfoFetched,
  currentSubscriptionFetched,
  subscriptionStatusUpdated,
} from 'actions/subscriptions'
import { subscriptionStatus } from '@farmtrx/options'

export const getSubscriptionDetails = () => {
  return (dispatch, getState) => {
    return http.get('/subscription').then((res) => {
      dispatch(subscriptionsFetched(res.data))
      const permissions = getState().account.permissions
      const hasPermission = permissions.includes('farm:write')
      res.data[0]?.['subscriptionPeriods']?.forEach((s) => {
        dispatch(getHarvestedArea(s.startDate, s.endDate))
        if (
          s.subscriptionStatus !== subscriptionStatus.FreeYear &&
          s.subscriptionStatus !== subscriptionStatus.Paid &&
          s.subscriptionStatus !== subscriptionStatus.Comped
        ) {
          if (hasPermission) {
            dispatch(getPaymentInfo(s.id))
          }
        }
      })
    })
  }
}

export const getHarvestedArea = (startDate, endDate) => {
  return (dispatch) => {
    return http
      .get('/harvest/area', {
        params: { startDate: startDate, endDate: endDate },
      })
      .then((res) => {
        dispatch(harvestedAreaFetched(res.data))
      })
  }
}

export const getPaymentInfo = (id) => {
  return (dispatch) => {
    return http.get(`/subscription/period/${id}/payment-link`).then((res) => {
      dispatch(paymentInfoFetched(id, res.data))
    })
  }
}

export const getCurrentSubscription = () => {
  return (dispatch) => {
    return http.get(`/subscription/status`).then((res) => {
      dispatch(currentSubscriptionFetched(res.data))
    })
  }
}

export const createSubscriptionPayment = (data) => {
  return () => {
    return http
      .post('/subscription/period/create-payment', data)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return error.message
      })
  }
}

export const updateSubscriptionStatus = (subscriptionPeriodId, newStatus) => {
  return (dispatch) => {
    const updatePayload = {
      subscriptionStatus: newStatus,
    }

    return http
      .put(`/subscription/period/${subscriptionPeriodId}`, updatePayload)
      .then((res) => {
        dispatch(subscriptionStatusUpdated(subscriptionPeriodId, newStatus))
        // Refresh subscription details to show updated status
        return dispatch(getSubscriptionDetails())
      })
      .catch((error) => {
        console.error('Failed to update subscription status:', error)
        throw error
      })
  }
}

export const createCheckoutSession = (subscriptionPeriodId, data) => {
  return () => {
    return http
      .post(
        `/subscription/period/${subscriptionPeriodId}/checkout-session`,
        data,
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        console.error('Failed to create checkout session:', error)
        throw error
      })
  }
}
